// extracted by mini-css-extract-plugin
export var gif = "_lp-0";